import { Stack } from '@mantine/core'

import { useGetVersion } from '@repo/common/queries/labs/versions'

export function VersionsPage() {
  const { data } = useGetVersion()
  return (
    <Stack>
      <div data-chromatic="ignore">
        Webapp Version:{' '}
        <a
          target="_blank"
          href={`https://github.com/fission-xyz/webapps/releases/tag/${__VERSION__.split('-')[0]}`}
          rel="noreferrer"
        >
          {__VERSION__}
        </a>{' '}
        @ {new Date(__VERSION_TIME__).toLocaleString()} - deployed @{' '}
        {new Date(__BUILT_TIME__).toLocaleString()}
      </div>
      <div>
        Server Version:{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://github.com/fission-xyz/backend/commit/${data?.version}`}
        >
          {data?.version.slice(0, 8)}
        </a>{' '}
        on{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://dashboard.heroku.com/apps/fission-${data?.app_env}`}
        >
          {data?.app_env}
        </a>
      </div>
    </Stack>
  )
}
